import React from "react"
import Card from "@react/shared/ui/Card"

// Formats a Money amount rendered by the server as { cents, currency_symbol }.
// Shared with TemplatesTable so the Money math lives in one place.
export const formatMoney = (cents, symbol) => {
  if (cents == null || isNaN(cents)) return "—"
  return `${(cents / 100).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${symbol || "€"}`
}

// 3-card library-wide summary strip. Values are pre-computed server-side and
// shipped as plain JSON so we don't reimplement the Money math client-side.
const StatsStrip = ({ stats }) => {
  const cells = [
    { label: I18n.t("quotes.project_quote_templates.stats.count_label"), value: String(stats.count),                             sub: I18n.t("quotes.project_quote_templates.stats.count_sub") },
    { label: I18n.t("quotes.project_quote_templates.stats.avg_label"),   value: formatMoney(stats.avg_cents, stats.currency_symbol),   sub: I18n.t("quotes.project_quote_templates.stats.avg_sub") },
    { label: I18n.t("quotes.project_quote_templates.stats.total_label"), value: formatMoney(stats.total_cents, stats.currency_symbol), sub: I18n.t("quotes.project_quote_templates.stats.total_sub") },
  ]

  return (
    <div className="grid grid-cols-3 gap-3 mb-6">
      {cells.map(c => (
        <Card key={c.label} padding="md" className="rounded-lg">
          <div className="text-xs text-slate-500">{c.label}</div>
          <div className="text-xl font-semibold text-slate-900 tabular-nums mt-1">{c.value}</div>
          <div className="text-xs text-slate-400 mt-1">{c.sub}</div>
        </Card>
      ))}
    </div>
  )
}

export default StatsStrip
